export const SocialStyle = theme => ({
	margin: {
		margin: 0
	}
})
